"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("./constants");
exports.props = withCompInfo_1.withCompInfo(['language'], function (_a) {
    var language = _a.language;
    return {
        language: constants_1.WIX_RECAPTCHA_LANGUAGE_MAP[language],
    };
});
//# sourceMappingURL=Captcha.js.map